/**
 * Decode HTML entities (&amp;, &lt;, &gt;, &quot;, etc.) in a string.
 *
 * Some backend data (e.g., timezone offsets like "(US &amp; Canada)") is
 * stored as HTML-encoded text rather than plain text. React renders text
 * content literally, so the entity shows up to the user instead of being
 * decoded. Use this helper at the data-display boundary to convert entities
 * back to their plain-text form.
 */
export const decodeHtmlEntities = (str) => {
  if (!str) return str
  const el = document.createElement('textarea')
  el.innerHTML = str
  return el.value
}
